import {onFind} from "@elements/init-modules-in-scope";
import {find,findIn, findAllIn, on} from '@elements/dom-utils';
import asyncAppend from "@elements/async-append";

const selectors = {
    base: '.js-cashback',
    button: '.js-cashback__remove',
    target: '.js-cashback__result',
    loading: '.js-cashback__loading',
    error: '.js-cashback__notifications',
};

export function init () {

    onFind(selectors.base, function (baseElement) {
        let button = findIn(selectors.button, baseElement);

        if (button) {
            on('click', function(evt){
                let url = evt.target.dataset.cashbackRemoveUrl || false;

                if(url) {
                    asyncAppend({
                        target: findAllIn(selectors.target, baseElement),
                        loading: findAllIn(selectors.loading, baseElement),
                        notifications: findAllIn(selectors.notifications, baseElement) || false
                    }, fetch(url,{method: "POST"}));
                } else {
                    console.warn("Cashback.js: no cashback remove Url set");
                }

            }, button);
        }
    });

}

